import { CompanyListQuery } from "../type/company";
import axiosClient from "./axiosClient";

export const getCompanyList = (query: CompanyListQuery) => {
  const url = `/company`;
  return axiosClient.get(url, { params: query });
};

export const companyApproval = ({ id, params }) => {
  const url = `/company/${id}/companyApproval`;
  return axiosClient.post(url, params);
};

export const createHomePageDetails = ({ id, params }) => {
  const url = `/company/${id}/uploadHomePageDetails`;
  return axiosClient.post(url, params, {
    headers: {
      ...(params.getHeaders?.() ?? { "Content-Type": "multipart/form-data" }),
    },
  });
};

export const updateHomePageDetails = ({ id, params }) => {
  const url = `/company/${id}/uploadUpdatedHomePageDetails`;
  return axiosClient.post(url, params, {
    headers: {
      ...(params.getHeaders?.() ?? { "Content-Type": "multipart/form-data" }),
    },
  });
};

export const updateCompany = ({ id, params }) => {
  const url = `/company/${id}`;
  return axiosClient.post(url, params);
};

export const getCompanyTheme = (params) => {
  return axiosClient.get("/company/companyTheme", params);
};

export const getCompanyInfo = (params) => {
  return axiosClient.get("/company/companyInfo", params);
};

export const updateCompanyDuringSignup = ({ id, params }) => {
  const url = `/company/${id}/updateCompanyDuringSignup`;
  return axiosClient.post(url, params);
};

export const getCompanyConnectiveDetails = (params) => {
  return axiosClient.get("/company/companyConnectiveDetails", params);
};

export const getComapnyStatictics = (id) => {
  const url = `/company/${id}/statictics`;
  return axiosClient.get(url);
};

export const validateCompanyInfo = (params) => {
  return axiosClient.get("/company/validateCompanyInfo", params);
};

export const extractCompanyDomain = () => {
  return axiosClient.get("/company/extractCompanyDomain");
};
